import * as React from 'react';
import { authenticationService } from '../../../services/authentication';
import { GoogleLogo } from '../Icons';

interface SocialButtonProps {
    identityProvider: string;
    text: string;
}

export function SocialButton(props: SocialButtonProps): JSX.Element {
    const urlQueryParameters = new URLSearchParams(window.location.search);

    return (
        <button className="btn btn-outline-primary btn-social" tabIndex={0} onClick={() => authenticationService.login(props.identityProvider, urlQueryParameters)}>
            <GoogleLogo width={'36px'} height={'36px'}/>
            {props.text}
        </button>
    );
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/authenticationCardComponents/SocialButton.tsx